module.exports = __webpack_public_path__ + "static/media/logo-udel.cc03e55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-udel.png
// module id = 1461
// module chunks = 0